/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortPropertyDto } from './sortPropertyDto';
import { JobV2Dto } from './jobV2Dto';

export interface PageDtoJobV2Dto {
  content?: Array<JobV2Dto>;
  firstPage?: boolean;
  lastPage?: boolean;
  nextPage?: boolean;
  number?: number;
  numberOfElements?: number;
  previousPage?: boolean;
  size?: number;
  sort?: Array<SortPropertyDto>;
  totalElements?: number;
  totalPages?: number;
}
